
<template>
  <v-btn v-if="tip"
         icon
         class="adjusttoicon">
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-icon :size="size ? size : 24"
                :color="color ? color : ''"
                v-text="icon ? icon: 'mdi-close'"
                v-bind="attrs"
                v-on="on" />
      </template>
      <span v-text="tip"></span>
    </v-tooltip>
  </v-btn>
  <v-btn v-else
         icon
         class="adjusttoicon">
    <v-icon :size="size ? size : 24"
            :color="color ? color : ''"
            v-text="icon ? icon: 'mdi-close'" />
  </v-btn>

</template>

<script>
export default {
  props: ["icon", "tip", "size", "color"],
  data() {
    return {};
  },
  methods: {},
};
</script>

<style>
/*
.adjusttoicon{
  height: unset !important;
  width: unset !important;
}
*/
</style>
